import { takeEvery, put, select, call } from 'redux-saga/effects';
import { INITIALSTATE, WIPESTATE, ShowPageDone } from '../../reducer/system/showPage'
import fetchApi from '../../../utils/api/fetchApi'

/**
 * showPage动作
 * @param args 参数列表
 */
export function* showPageAsync(...args: any): Generator<any, any, any> {
    try {
        // const [{ isWipe }, action] = args;
        // console.log('清空数据: ', isWipe);
        // console.log('action : ', action);
        const [{ isWipe }] = args;
        /** 获取state中的showPageData */
        const showPageData = yield select(state => state.showPageData)
        let { apiId } = showPageData;
        if (!apiId || !showPageData[apiId]) {
            console.error('showPageSaga: apiId 无效或数据未初始化');
            return;
        }
        /** req.query */
        const query = {
            apiId,
            apiExtend: 'showPage',
            apiData: {
                // ...showPageData[apiId]?.data,
                current: showPageData[apiId].data.current,
                pageSize: showPageData[apiId].data.pageSize,
                queryString: showPageData[apiId].data.queryString,
                orderByString: showPageData[apiId].data.orderByString,
                useBak: showPageData[apiId].data.useBak,
                //Request query 传送数组方法:
                //前台传送时JSON.stringify(数组对象),后台JSON.parse(数组对象)
                sendPageData: showPageData[apiId].sendPageData,
            }
        };
        let sendPageData = {} as any;
        if (isWipe === true) {
            sendPageData[apiId] = showPageData[apiId];
            sendPageData[apiId].data.rows = undefined;
            sendPageData[apiId].data.total = 0;
        } else {
            const returnData = yield call(
                fetchApi.GET,
                showPageData[apiId].fetchUrl,
                query)
            sendPageData[apiId] = returnData;
        }
        sendPageData[apiId].fetchUrl = showPageData[apiId].fetchUrl;
        sendPageData[apiId].sendPageData = showPageData[apiId].sendPageData;
        const payload: any = {
            ...showPageData,
            ...sendPageData
        }
        yield put(ShowPageDone(payload));
    }
    catch (err: any) {
        console.log('showPageSaga Error:');
        console.log(err);
    }
}

export function* watchShowPageAsync() {
    yield takeEvery(WIPESTATE, showPageAsync, { isWipe: true });
    yield takeEvery(INITIALSTATE, showPageAsync, { isWipe: false });
}